import type { AdvancedFilterQuery } from '@packages/types';
import type { ActiveFilter } from './filter-metadata.types';
import { FilterOperatorType } from './filter-metadata.types';

/**
 * Types for the PatientFiltersPanel component
 */

export type FieldKey = string;
export type GroupOperator = 'AND' | 'OR';
export type ConditionOperator =
    | 'equals'
    | 'contains'
    | 'between'
    | 'greaterThan'
    | 'lessThan'
    | 'in'
    | 'exists'
    | 'not_exists';

export interface FilterCondition {
    id: string;
    field: FieldKey;
    operator?: ConditionOperator;
    value?: any;
    conditionOperator?: GroupOperator; // Operator between this condition and the previous one
}

export interface FilterGroup {
    id: string;
    operator: GroupOperator;
    conditions: FilterCondition[];
}

export interface PatientFiltersPanelProps {
    // Preferred: work with AdvancedFilterQuery directly
    value?: AdvancedFilterQuery;
    onAdvancedFiltersChange?: (filters?: AdvancedFilterQuery) => void;
    // Back-compat (not used now, but kept for compatibility)
    onFiltersChange?: (filters: ActiveFilter[]) => void;
    initialFilters?: ActiveFilter[];
    messageId?: string | null;
    /** Rendered below "Add Filter Group" / "Clear All" row (e.g. ES+OMOP switch) */
    slotAfterToolbar?: React.ReactNode;
}

/**
 * Map FilterOperatorType enum to ConditionOperator string
 */
export const mapDefaultOperator = (op?: FilterOperatorType): ConditionOperator | undefined => {
    if (!op) return undefined;
    switch (op) {
        case FilterOperatorType.EQUALS:
            return 'equals';
        case FilterOperatorType.CONTAINS:
            return 'contains';
        case FilterOperatorType.IN:
            return 'in';
        case FilterOperatorType.BETWEEN:
            return 'between';
        case FilterOperatorType.GREATER_THAN:
            return 'greaterThan';
        case FilterOperatorType.LESS_THAN:
            return 'lessThan';
        default:
            return undefined;
    }
};
